<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="shareDeviceForm">
		<div class="flex justify-content-center" *ngIf="deviceSharing">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
		<div *ngIf="!deviceSharing">
			<div class="grid">
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.firstName, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.firstName, 'label')">{{ 'FIRST_NAME' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.firstName, 'borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-share-input-firstName"
								formControlName="firstName" autocomplete="device-firstName"
								placeholder="{{ 'FIRST_NAME' | translate }}" maxlength="40" />
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.firstName)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
				</div>
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.lastName, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.lastName, 'label')">{{ 'LAST_NAME' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.lastName, 'borderInput')">
							<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="device-share-input-lastName"
								formControlName="lastName" autocomplete="device-lastName"
								placeholder="{{ 'LAST_NAME' | translate }}" maxlength="40" />
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.lastName)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
				</div>
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.email, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.email, 'label')">{{ 'EMAIL' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.email, 'borderInput')">
							<input type="text" pInputText noSpaces [ngClass]="dynamicInputTextWidth()" id="device-share-input-email"
								formControlName="email" autocomplete="device-email" placeholder="{{ 'EMAIL' | translate }}"
								maxlength="200"/>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.email)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyMessagesNewValidator()">{{ 'EMAIL_ADDRESS_INVALID' | translate }}</small>
				</div>
				<div [class]="col12Responsive()">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'borderRow','notEquivalentEmail')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'label','notEquivalentEmail')">{{
							'CONFIRM_EMAIL' | translate }}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="showErrorsConfirmFields(this.f.emailConfirm, 'borderInput','notEquivalentEmail')">
							<input type="text" pInputText noSpaces [ngClass]="dynamicInputTextWidth()"
								id="device-share-input-emailConfirm" formControlName="emailConfirm"
								autocomplete="device-emailConfirm" placeholder="{{ 'CONFIRM_EMAIL' | translate }}"
								maxlength="200" />
						</div>
					</div>
					<small *ngIf="showErrorConfirmInvalidMessage(this.f.emailConfirm,'notEquivalentEmail')"
						class="flex align-items-center text-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{
						'EMAIL_CONFIRM_ADDRESS_INVALID' | translate }}</small>
				</div>
				<div class="col-12" [ngClass]="customPaddingX()" *ngIf="this.mobileRemotesSupport">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="newShowErrors(this.f.remotesMax, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.remotesMax, 'label')">{{ 'MAX_REMOTES_APP_AUTOMATION' | translate
							}}</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="newShowErrors(this.f.remotesMax, 'borderInput')">
							<p-dropdown formControlName="remotesMax" [options]="clientsNum" [ngClass]="dynamicInputTextWidth()"
								appendTo="body" styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
								id="device-share-remotes" placeholder="{{ 'MAX_REMOTES_APP_AUTOMATION' | translate }}">
								<ng-template let-item pTemplate="selectedItem">
									<div class="item" class="flex align-items-center justify-content-center">
										<div class="flex justify-content-center">{{ item }}</div>
									</div>
								</ng-template>
								<ng-template let-item pTemplate="item">
									<div class="item flex align-items-center justify-content-center">
										<div>{{ item }}</div>
									</div>
								</ng-template>
							</p-dropdown>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.remotesMax)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
				</div>
			</div>

			<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
				<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
					class="p-button-primary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
				<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
					class="p-button-secondary text-xl font-normal mt-2 mx-1" [ngClass]="dynamicButtonWidth()">
				</button>
			</div>
		</div>
	</form>
</div>